import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    marginRight: theme.spacing(2),
  },
}));

export default useStyles;
